import _slicedToArray from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { Node, mergeAttributes, Mark, getMarkAttributes, wrappingInputRule } from '@tiptap/core';
var ListItem = Node.create({
  name: 'listItem',
  addOptions: function addOptions() {
    return {
      HTMLAttributes: {},
      bulletListTypeName: 'bulletList',
      orderedListTypeName: 'orderedList'
    };
  },
  content: 'paragraph block*',
  defining: true,
  parseHTML: function parseHTML() {
    return [{
      tag: 'li'
    }];
  },
  renderHTML: function renderHTML(_ref) {
    var HTMLAttributes = _ref.HTMLAttributes;
    return ['li', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
  },
  addKeyboardShortcuts: function addKeyboardShortcuts() {
    var _this = this;
    return {
      Enter: function Enter() {
        return _this.editor.commands.splitListItem(_this.name);
      },
      Tab: function Tab() {
        return _this.editor.commands.sinkListItem(_this.name);
      },
      'Shift-Tab': function ShiftTab() {
        return _this.editor.commands.liftListItem(_this.name);
      }
    };
  }
});
var TextStyle = Mark.create({
  name: 'textStyle',
  addOptions: function addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML: function parseHTML() {
    return [{
      tag: 'span',
      getAttrs: function getAttrs(element) {
        var hasStyles = element.hasAttribute('style');
        if (!hasStyles) {
          return false;
        }
        return {};
      }
    }];
  },
  renderHTML: function renderHTML(_ref2) {
    var HTMLAttributes = _ref2.HTMLAttributes;
    return ['span', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
  },
  addCommands: function addCommands() {
    var _this2 = this;
    return {
      removeEmptyTextStyle: function removeEmptyTextStyle() {
        return function (_ref3) {
          var state = _ref3.state,
            commands = _ref3.commands;
          var attributes = getMarkAttributes(state, _this2.type);
          var hasStyles = Object.entries(attributes).some(function (_ref4) {
            var _ref5 = _slicedToArray(_ref4, 2),
              value = _ref5[1];
            return !!value;
          });
          if (hasStyles) {
            return true;
          }
          return commands.unsetMark(_this2.name);
        };
      }
    };
  }
});
var inputRegex = /^\s*([-+*])\s$/;
var BulletList = Node.create({
  name: 'bulletList',
  addOptions: function addOptions() {
    return {
      itemTypeName: 'listItem',
      HTMLAttributes: {},
      keepMarks: false,
      keepAttributes: false
    };
  },
  group: 'block list',
  content: function content() {
    return "".concat(this.options.itemTypeName, "+");
  },
  parseHTML: function parseHTML() {
    return [{
      tag: 'ul'
    }];
  },
  renderHTML: function renderHTML(_ref6) {
    var HTMLAttributes = _ref6.HTMLAttributes;
    return ['ul', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
  },
  addCommands: function addCommands() {
    var _this3 = this;
    return {
      toggleBulletList: function toggleBulletList() {
        return function (_ref7) {
          var commands = _ref7.commands,
            chain = _ref7.chain;
          if (_this3.options.keepAttributes) {
            return chain().toggleList(_this3.name, _this3.options.itemTypeName, _this3.options.keepMarks).updateAttributes(ListItem.name, _this3.editor.getAttributes(TextStyle.name)).run();
          }
          return commands.toggleList(_this3.name, _this3.options.itemTypeName, _this3.options.keepMarks);
        };
      }
    };
  },
  addKeyboardShortcuts: function addKeyboardShortcuts() {
    var _this4 = this;
    return {
      'Mod-Shift-8': function ModShift8() {
        return _this4.editor.commands.toggleBulletList();
      }
    };
  },
  addInputRules: function addInputRules() {
    var _this5 = this;
    var inputRule = wrappingInputRule({
      find: inputRegex,
      type: this.type
    });
    if (this.options.keepMarks || this.options.keepAttributes) {
      inputRule = wrappingInputRule({
        find: inputRegex,
        type: this.type,
        keepMarks: this.options.keepMarks,
        keepAttributes: this.options.keepAttributes,
        getAttributes: function getAttributes() {
          return _this5.editor.getAttributes(TextStyle.name);
        },
        editor: this.editor
      });
    }
    return [inputRule];
  }
});
export { BulletList, BulletList as default, inputRegex };